export default __webpack_public_path__ + "static/media/aws_white.f571265a.svg";